export default "__VITE_ASSET__ee5ae16e__"